export default __webpack_public_path__ + "locales/pl/Payments.json?hash=0de964e66fa21134dfeb4047c5fac8e8";